import {useContext} from 'react';
import {EnvironmentContext} from "../context/EnvironmentProvider";
import Environment from "../services/interfaces/Environment";

export const useEnvironment = (): Environment => {
    const context = useContext(EnvironmentContext);

    if (context === undefined) {
        throw new Error();
    }

    return context;
};
